import { TranslationMapping } from "../../messages";
import * as Subtitle from "../../subtitle_lib/subtitle_lib";

export function getSubtitleByLanguage(
  language: keyof TranslationMapping<string>,
  subtitles?: TranslationMapping<string> | null
) {
  if (subtitles === null || subtitles === undefined) {
    return null;
  }

  const subtitle = subtitles[language];

  if (subtitle !== undefined) {
    return subtitle;
  }

  return null;
}

export function shuffle<T>(original: T[]): T[] {
  const a = original.slice();
  let j;
  let x;
  let i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}

export function getCurrentSubtitle(subtitles: Subtitle.SubTitleType[], time: number): string {
  // Find index
  let i = 0;

  while (i < subtitles.length && subtitles[i].start < time) {
    i++;
  }
  i--;

  if (i >= subtitles.length || i === -1) {
    return "";
  } else {
    if (subtitles[i].end > time) {
      return subtitles[i].text;
    } else {
      return "";
    }
  }
}
